export const signUpStatus = {
  ON_WAITING_LIST: 'ON_WAITING_LIST',
  SIGNED_UP: 'SIGNED_UP',
  FAILED_SIGN_UP: 'FAILED_SIGN_UP',
};

export const badgesType = {
  BRANDED: 'BRANDED',
  DEFAULT: 'DEFAULT',
  SAFETY: 'SAFETY',
  TRYP_STOPS: 'TRYP_STOPS',
  COMPANY: 'COMPANY',
  PLAYGROUND: 'PLAYGROUND',
};

export const urls = {
  defaultGitsUrl: 'https://gist.githubusercontent.com/manoj382/7002075/raw/44e017dfbd553f9a7c765ad46ef4f38450fc6799/canT.json',
};

export const countryCodes = {
  BO: 'BO',
  CA: 'CA',
  GB: 'GB',
  US: 'US',
};

export const actionsContest = {
  TRIVIA_COMPLETED: 'TRIVIA_COMPLETED',
  PYN_COLLECTED: 'PYN_COLLECTED',
  PYN_COLLECTED_FILTERED: 'PYN_COLLECTED_FILTERED',
  WEEKLY_MISSION_COMPLETED: 'WEEKLY_MISSION_COMPLETED',
};

export const contestTypes = {
  ANNUAL: 'ANNUAL',
  MONTHLY: 'MONTHLY',
  WEEKLY: 'WEEKLY',
  DAILY: 'DAILY',
};

export const timezones = ['America/Edmonton', 'America/La_Paz', 'America/Los_Angeles', 'America/Chicago', 'America/Creston', 'America/Denver', 'America/New_York'];

export const typeWeeklyMission = {
  sponsor: 'Sponsor',
  education: 'Education',
  inApp: 'In-App',
};

export const subTypeInAppMission = {
  greenTryps: 'greenTryps',
  newFriend: 'newFriend',
  trivias: 'trivias',
  highScore: 'highScore',
  trypScores: 'trypScores',
  phoneUseScores: 'phoneUseScores',
  handlingScore: 'handlingScore',
  focusScore: 'focusScore',
  ecoScore: 'ecoScore',
  accelerationScore: 'accelerationScore',
  brakeScore: 'brakeScore',
  corneringScore: 'corneringScore',
  steadinessScore: 'steadinessScore',
  swerveScore: 'swerveScore',
  speedingScore: 'speedingScore',
};

export const missionScores = ['highScore', 'trypScores', 'phoneUseScores', 'handlingScore', 'focusScore', 'ecoScore', 'accelerationScore', 'brakeScore', 'corneringScore', 'steadinessScore', 'swerveScore', 'speedingScore'];

export const notificationsType = {
  TRYP_STREAK: 'TRYP_STREAK',
  REWARD_REDEEMED: 'REWARD_REDEEMED',
  TRIVIA: 'TRIVIA',
  BADGE: 'BADGE',
  MISSION: 'MISSION',
  WIN_CONTEST: 'WIN_CONTEST',
  CUSTOM: 'CUSTOM',
};

export const waitListConfig = {
  WAIT_LIST: 'WAIT_LIST',
  ALL_USERS: 'ALL_USERS',
  FULL_USERS: 'FULL_USERS',
  FULL_NAME: 'FULL_NAME',
};

export const profileFields = {
  EMAIL: 'email',
  SIGN_UP_STATUS: 'signUpStatus',
  COUNTRY_CODE: 'countryCode',
  STATE_CODE: 'stateCode',
  UPDATED_AT: 'updatedAt',
  CREATED_AT: 'createdAt',
  LEVEL: 'level',
};

export const profileSortingOptions = {
  EMAIL: 'email',
  FIRST_NAME: 'name',
  LAST_NAME: 'lastName',
};
